import { ApolloClient, ApolloLink } from '@apollo/client';
import { getApolloDevToolsEnabled } from '@lingoda/config';
import {
    getAuthRestLink,
    getErrorLink,
    getHeadersConfigLink,
    getRestLink,
    getRetryLink,
    getUploadLink,
} from '@lingoda/monolith-graphql-client';
import { getGraphQLCache } from '@lingoda/monolith-graphql-cache';
import { MonitorLink } from '@lingoda/monitor';
import { goTo, teacherLogoutPath } from '@lingoda/router';

export const createMonolithClient = () => {
    return new ApolloClient({
        cache: getGraphQLCache(),
        link: ApolloLink.from([
            new MonitorLink({ setTransaction: false, setFingerprint: false }),
            getErrorLink({
                onUnauthorized: () => {
                    goTo(teacherLogoutPath());
                },
            }),
            getRetryLink(),
            getAuthRestLink({
                onUnauthorized: () => {
                    goTo(teacherLogoutPath());
                },
            }),
            getHeadersConfigLink(),
            getRestLink(),
            getUploadLink({ uri: '/graphql' }),
        ]),
        devtools: {
            enabled: getApolloDevToolsEnabled(),
            name: 'Monolith',
        },
    });
};
